import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetIndicadoresUseCase } from "../../../presentation/useCases/read/get_all_indicadores_use_case";
import { EquipamentoMedIndicadores } from "../../models/EquipamentoMed_indicadores";

import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

export class GetAllIndicadoresUseCase
  extends BasePaginatedUseCase<EquipamentoMedIndicadores>
  implements IGetIndicadoresUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) {
    super();
  }

  async getAllIndicadores(): Promise<EquipamentoMedIndicadores> {

    const response = await this.repository.getAllIndicadores();
    return response;
  }
}
